// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-E":"E_power-ocean-home-E__82Eho"};